module.exports = __webpack_public_path__ + "static/img/binzhou3.e60993ef.jpg";